/* global $ */

function slideUp(
  el,
  openingClass = "topnav-opening",
  openClass = "topnav-open",
) {
  const element = el;
  const height = element.offsetHeight;

  element.style.height = `${height}px`;

  element.classList.remove(openClass);
  element.classList.add(openingClass);
  // eslint-disable-next-line no-unused-expressions
  element.offsetHeight;
  element.style.height = "";

  setTimeout(() => {
    element.classList.remove(openingClass);
  }, 300);
}

function slideDown(
  el,
  openingClass = "topnav-opening",
  openClass = "topnav-open",
) {
  const element = el;

  element.style.display = "block";
  const height = element.offsetHeight;
  element.style.display = "";

  element.classList.add(openingClass);
  // eslint-disable-next-line no-unused-expressions
  element.offsetHeight;
  element.style.height = `${height}px`;

  setTimeout(() => {
    element.classList.add(openClass);
    element.classList.remove(openingClass);
    element.style.height = "";
  }, 300);
}

(function headerDropdown() {
  const toggle = document.getElementById("togglenav");
  const toggleIcon = document.getElementById("toggle-icon");
  const menu = document.getElementById("topnav");
  const menuInner = document.getElementById("primary-menu");
  const parentItems = menuInner.querySelectorAll(".menu-item-has-children");

  // On toggle button click show menu and toggle icon classes
  toggle.addEventListener("click", () => {
    if (!menu.classList.contains("topnav-opening")) {
      if (menu.classList.contains("topnav-open")) {
        // Close the menu
        toggleIcon.classList.remove("fa-times");
        toggleIcon.classList.add("fa-bars");

        slideUp(menu);
      } else {
        // Open the menu
        toggleIcon.classList.remove("fa-bars");
        toggleIcon.classList.add("fa-times");

        slideDown(menu);
      }
    }
  });

  parentItems.forEach(item => {
    const subToggle = document.createElement("button");
    const subToggleIcon = document.createElement("i");
    const subNav = item.querySelector("ul");

    subToggle.classList.add("sub-menu-toggle");

    subToggleIcon.classList.add("fa");
    subToggleIcon.classList.add(
      item.classList.contains("current-menu-parent") ||
      item.classList.contains("current-menu-item")
        ? "fa-caret-up"
        : "fa-caret-down",
    );

    subToggle.appendChild(subToggleIcon);
    item.insertBefore(subToggle, subNav);

    item.addEventListener("click", e => {
      if (e.target.closest(".sub-menu")) {
        return;
      }

      subToggleIcon.classList.toggle("fa-caret-up");
      subToggleIcon.classList.toggle("fa-caret-down");

      [...parentItems]
        .filter(parentItem => parentItem !== item)
        .forEach(parentItem => {
          const nav = parentItem.querySelector("ul");
          const parentIcon = parentItem.querySelector(".sub-menu-toggle i");

          parentIcon.classList.add("fa-caret-down");
          parentIcon.classList.remove("fa-caret-up");

          if (window.matchMedia("(min-width: 820px)").matches) {
            nav.style.display = "none";
            parentItem.classList.remove("current-menu-parent");
            parentItem.classList.remove("current-menu-item");
          } else {
            JQueryStatic(nav).slideUp(300, () => {
              parentItem.classList.remove("current-menu-parent");
              parentItem.classList.remove("current-menu-item");
            });
          }
        });

      JQueryStatic(subNav).slideToggle(300, () => {
        item.classList.toggle("current-menu-parent");
        item.classList.toggle("current-menu-item");
      });

      e.preventDefault();
      e.stopPropagation();
    });
  });
})();
